import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

/**
 * Shown when a non–super-admin user opens /GlobalProductTypes.
 * The full CSV import UI only exists under the admin layout (AdminMain).
 */
const GlobalProductTypesAccessDenied = () => (
    <div>
        <Helmet>
            <title>Product types (CSV) — access</title>
        </Helmet>
        <Paper style={{ margin: 16, padding: 24, maxWidth: 640 }}>
            <Typography variant="h6" gutterBottom>
                Product types (CSV) — administrator only
            </Typography>
            <Typography variant="body2" color="textSecondary" paragraph>
                This screen is only available in the <strong>super administrator</strong> portal. Your
                current session is using the manufacturer (or distributor) layout, so the import UI is
                not mounted here.
            </Typography>
            <Typography variant="body2" color="textSecondary" paragraph>
                If you should have access, sign out and sign in again with a super administrator account,
                then open <strong>Product types (CSV)</strong> from the admin menu.
            </Typography>
            <Button component={Link} to="/dashboard/" variant="contained" color="primary">
                Back to dashboard
            </Button>
        </Paper>
    </div>
);

export default GlobalProductTypesAccessDenied;
